// src/data/initialCurveData.js
// Converted from your Printlogic markup tables

export const INITIAL_CURVE_DATA = {
  letterheads: {
    retail: {
      controlPoints: [
        { quantity: 1, margin: 256 },
        { quantity: 256, margin: 256 },
        { quantity: 257, margin: 365 },
        { quantity: 359, margin: 365 },
        { quantity: 360, margin: 451 },
        { quantity: 433, margin: 451 },
        { quantity: 434, margin: 563 },
        { quantity: 503, margin: 563 },
        { quantity: 504, margin: 540 },
        { quantity: 761, margin: 540 },
        { quantity: 762, margin: 527 },
        { quantity: 1007, margin: 527 },
        { quantity: 1008, margin: 497 },
        { quantity: 1511, margin: 497 },
        { quantity: 1512, margin: 426 },
        { quantity: 2013, margin: 426 },
        { quantity: 2014, margin: 371 },
        { quantity: 2561, margin: 371 },
        { quantity: 2562, margin: 308 },
        { quantity: 3009, margin: 308 },
        { quantity: 3010, margin: 305 },
        { quantity: 3511, margin: 305 },
        { quantity: 3512, margin: 299 },
        { quantity: 4003, margin: 299 },
        { quantity: 4004, margin: 282 },
        { quantity: 4509, margin: 282 },
        { quantity: 4510, margin: 264 }
      ],
      metadata: {
        jobType: 'letterheads',
        customerTier: 'retail',
        description: 'Letterhead pricing curve - relatively flat with small decreases',
        minMargin: 200,
        maxMargin: 600
      }
    }
  },
  
  booklets: {
    retail: {
      controlPoints: [
        { quantity: 1, margin: 385.55 },
        { quantity: 50, margin: 385.55 },
        { quantity: 51, margin: 370 },
        { quantity: 100, margin: 370 },
        { quantity: 101, margin: 355 },
        { quantity: 150, margin: 355 },
        { quantity: 151, margin: 341 },
        { quantity: 200, margin: 341 },
        { quantity: 201, margin: 327 },
        { quantity: 250, margin: 327 },
        { quantity: 251, margin: 314 },
        { quantity: 300, margin: 314 },
        { quantity: 301, margin: 301 },
        { quantity: 350, margin: 301 },
        { quantity: 351, margin: 289 },
        { quantity: 400, margin: 289 },
        { quantity: 401, margin: 277 },
        { quantity: 450, margin: 277 },
        { quantity: 451, margin: 266 },
        { quantity: 500, margin: 266 },
        { quantity: 501, margin: 245 },
        { quantity: 600, margin: 245 },
        { quantity: 601, margin: 226 },
        { quantity: 700, margin: 226 },
        { quantity: 701, margin: 209 },
        { quantity: 800, margin: 209 },
        { quantity: 801, margin: 194 },
        { quantity: 900, margin: 194 },
        { quantity: 901, margin: 181 },
        { quantity: 1000, margin: 181 },
        { quantity: 1001, margin: 170 },
        { quantity: 1100, margin: 170 },
        { quantity: 1101, margin: 161 },
        { quantity: 1200, margin: 161 },
        { quantity: 1201, margin: 153 },
        { quantity: 1300, margin: 153 },
        { quantity: 1301, margin: 144 },
        { quantity: 1400, margin: 144 },
        { quantity: 1401, margin: 135 }
      ],
      metadata: {
        jobType: 'booklets',
        customerTier: 'retail',
        description: 'Booklet pricing curve - steep decline reflecting digital vs litho economics',
        minMargin: 100,
        maxMargin: 450
      }
    }
  }
};

// Utility to get curve data
export const getCurveData = (jobType, customerTier = 'retail') => {
  return INITIAL_CURVE_DATA[jobType]?.[customerTier] || null;
};

// Utility to get all job types
export const getAvailableJobTypes = () => {
  return Object.keys(INITIAL_CURVE_DATA);
};